import { render } from "./add.status.vue?vue&type=template&id=f0cb00a8&lang=html"
import script from "./add.status.vue?vue&type=script&lang=js"
export * from "./add.status.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__